import { Injectable } from '@angular/core';
import { select } from '@ngneat/elf';
import { BaseStoreRepository } from '../base-store.repository';
import { bankDetailsInitialState, BankDetailsStateProps, bankDetailsStateStore } from './bank-details-state.store';

@Injectable({
  providedIn: 'root',
})
export class BankDetailsRepository extends BaseStoreRepository<BankDetailsStateProps> {
  constructor() {
    super(bankDetailsStateStore.pipe(select(state => state)), bankDetailsStateStore, bankDetailsInitialState);
  }
}
